const header = {
  homepage: 'https://www.linkedin.com/in/mihai-gabriel1/',
  title: 'GM.',
}

const about = {
  name: 'Gabriel Mihai',
  role: 'Front-End Dev',
  description:
    'Frontend Developer with a strong foundation in HTML, CSS, JavaScript, and the React library. Skilled in creating user-friendly websites that meet customer requirements and a track record of successfully collaborating with clients. Commited to delivering quality results and continuously developing my skills.',
  resume:
    'https://www.dropbox.com/s/d7k7koqfcolhsoe/CV-Gabriel_Mihai%20%20%281%29.pdf?dl=0',
  social: {
    linkedin: 'https://www.linkedin.com/in/mihai-gabriel1/',
    github: 'https://github.com/mihai-gabriel1',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'ReactJS - Healthcare Website',
    description:
      'A Pneumology healthcare website, built using the ReactJS library, and the latest Bootstrap framework.',
    stack: ['ReactJS', 'Bootstrap 5', 'SCSS'],
    sourceCode: 'https://github.com/mihai-gabriel1/reactjs-medical-website',
    livePreview: 'https://www.alicrantamedicalcenter.com/',
  },
  {
    name: 'ReactJS-Firebase Netflix Clone',
    description:
      'A Netflix clone built using ReactJs, getting real time data using themoviedb Api, using Firebase and Firestore for the backend.',
    stack: ['SASS', 'ReactJS', 'TailwindCSS', 'Firebase'],
    sourceCode:
      'https://github.com/mihai-gabriel1/Netflix-Clone-ReactJs-Firebase',
    livePreview: 'https://netflixandchillreactjs.netlify.app/',
  },
  {
    name: 'ReactJS / PHP Laravel',
    description:
      'Advertising website, created using ReactJS for frontend, and PHP/Laravel for the backend part, along with Mysql DB.',
    stack: ['SASS', 'Bootstrap', 'ReactJS'],
    sourceCode: 'https://github.com/mihai-gabriel1/ads-website',
    livePreview: 'https://github.com/mihai-gabriel1/ads-website',
  },
  {
    name: 'NextJS Admin Dashboard',
    description:
      'A simple yet advanced and fancy dashboard, created using Nextjs and TailwindCSS for styling.',
    stack: ['NextJS', 'TailwindCSS', 'SCSS'],
    sourceCode: 'https://github.com/mihai-gabriel1/nextjs-user-dashboard',
    livePreview: 'https://fancynextjsdash.netlify.app/',
  },
  {
    name: 'ReactJS Ecommerce Shop',
    description:
      'A simple ecommerce shop done in Reactjs and Bootstrap framework for styling.',
    stack: ['SASS', 'Bootstrap', 'ReactJS'],
    sourceCode: 'https://github.com/mihai-gabriel1/reactjs-ecommerce-shop',
    livePreview: 'https://fancyreactjsshop.netlify.app/',
  },
  {
    name: 'ReactJS Traveling Blog',
    description: 'A simple traveling blog, created using the ReactJS library.',
    stack: ['SASS', 'Bootstrap', 'ReactJS'],
    sourceCode: 'https://github.com/mihai-gabriel1/Traveling-blog',
    livePreview: 'https://the-traveling-blog.netlify.app/',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'HTML',
  'CSS',
  'JavaScript',
  'TailwindCSS',
  'Bootstrap',
  'TypeScript',
  'ReactJS',
  'NextJS',
  'Redux',
  'SASS',
  'Laravel',
  'MYSQL',
  'Material UI',
  'Git',
  'CI/CD',
  'Jest',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'mr.eu21@gmail.com',
}

export { header, about, projects, skills, contact }
